<template>
  <div :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <template>
            <a-col :md="8" :sm="12">
              <a-form-item label="Date">
                <a-range-picker v-model="queryParam.createdTime" format="YYYY-MM-DD" />
              </a-form-item>
            </a-col>
          </template>
          <a-col :md="6" :sm="8">
            <a-form-item label="Status">
              <a-select v-model="queryParam.statuses" :placeholder="$t('select')" style="width: 100%" mode="multiple" :allowClear='allowClear'>
                <a-select-option v-for='item in statuses' :key='item.dictValue'>
                  {{item.dictTextCn}}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="8">
            <a-form-item label="Internal Group Name">
              <a-input v-model="queryParam.name" :allowClear='allowClear'></a-input>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="8">
            <a-form-item label="Third-party Group Name">
              <a-input v-model="queryParam.thirdName" :allowClear='allowClear'></a-input>
            </a-form-item>
          </a-col>
          <a-col :md="8" :sm="8">
            <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search">{{ $t('search') }}</a-button>
              <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">{{ $t('reset') }}</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
      <a-table
        ref="table"
        size="middle"
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="false"
        :loading="loading"
        :scroll="{ x: 1500 }"
        :rowClassName='rowClassName'
        bordered>
        <span slot="action" slot-scope="text, record">
          <template v-if='record.status!=4'>
             <a @click="handleEdit(record)">{{ $t('edit') }}</a>
             <a-divider type="vertical" v-if='record.status!=10'/>
             <a @click="toDonghaoHandle(record)" v-if='record.status!=10'>Hao Ge Processing</a>
          </template>
          <template v-if='record.status==4'>
             <a @click="handleEditDetail(record)">Details</a>
             <a-divider type="vertical" v-if='fourToOtherSwitch == "on1"'/>
             <a @click="toDonghaoHandle(record)" v-if='fourToOtherSwitch == "on1"'>Hao Ge Processing</a>
          </template>
        </span>
      </a-table>
      <div style="margin-top: 15px; text-align: right;">
        <v-pagination
          v-if="total"
          :page-num="queryParam.pageNum"
          :page-size="queryParam.pageSize"
          :total="total"
          @change="handleTableChange" />
      </div>
      <order-filing-tax-group-update-model ref="modalForm" :page-type='pageType' :statuses='statuses' :group-id='groupId' @ok="modalFormOk"></order-filing-tax-group-update-model>
    </div>
  </div>
</template>
<script>
import { filingTaxGroupList, filingTaxGroupUpdate, filingTaxGroupUpdate1, listPre } from '@/webpublicapi/order'
import { filterObj } from '@/utils/util'
import moment from 'moment/moment'
import OrderFilingTaxGroupUpdateModel from './modules/OrderFilingTaxGroupUpdateModel'
export default {
  name: 'OrderFilingTaxGroup',
  components: {
    OrderFilingTaxGroupUpdateModel,
  },
  data () {
    return {
      loading: false,
      allowClear: true,
      total: 0,
      groupId: null,
      types: [],
      errorMessage: '',
      toggleSearchStatus:false,
      fourToOtherSwitch: 'off',
      status: '',
      tag: '',
      curtags:[],
      tags: [],
      // statuses: [{"value":"0", "label":"Pending tax filing"},{"value":"1", "label":"In progress"},{"value":"2", "label":"Info error"},{"value":"3", "label":"Fill in error"},{"value":"4", "label":"Tax filing completed"},{"value":"5", "label":"No tax filing"},{"value":"6", "label":"Pending confirmation"},{"value":"10", "label":"Handle by Hao"}],
      statuses: [],
      pageType: '',
      queryParam: {
        name: '',
        thirdName: '',
        pageNum: 1,
        pageSize: 10,
        statuses: [],
        createdTime: [],
      },
      visible: false,
      dataSource: [],
    }
  },
  computed: {
    // Table header
    columns () {
      return [
        {
          title: "ID",
          dataIndex: 'id',
          align:"center",
          width:80,
        },
        {
          title: "Group Name",
          dataIndex: 'name',
          align:"center",
          width:200,
        },
        {
          title: "Third-party Group Name",
          dataIndex: 'thirdName',
          align:"center",
          width:200,
        },
        {
          title: "Status",
          align: 'center',
          width: 150,
          dataIndex: 'status',
          customRender: (text, record) => {
            var text = text;
            if(text != undefined && text != null && text != '') {
              for(var i in this.statuses) {
                if(text === this.statuses[i].dictValue) {
                  return this.statuses[i].dictTextCn
                }
              }
            } else {
              return '';
            }
          },
        },
        {
          title: "TaskQuantity",
          dataIndex: 'num',
          align:"center",
          width:100,
        },
        {
          title: "Info",
          dataIndex: 'message',
          align:"center",
          width:300,
        },
        {
          title: "Address",
          dataIndex: 'path',
          align:"center",
          width:200,
        },
        {
          title: "Created Time",
          align:"center",
          width:170,
          dataIndex: 'createTime',
        },
        {
          title: "Updated Time",
          align:"center",
          width:170,
          dataIndex: 'updateTime',
        },
        {
          title: "Action",
          dataIndex: 'action',
          align:"center",
          width:200,
          fixed: 'right',
          scopedSlots: { customRender: 'action' },
        }]
    },
  },
  created () {
    this.loadBaseData();
    this.loadData('');
  },
  methods: {
    loadBaseData(){
      listPre({}).then((res) => {
        if (res.code === 1000) {
          this.statuses = res.data.statuses
          this.tags = res.data.tags
          this.fourToOtherSwitch = res.data.fourToOtherSwitch
          if(this.fourToOtherSwitch == null || this.fourToOtherSwitch == undefined || this.fourToOtherSwitch == '') {
            this.fourToOtherSwitch = 'off'
          }
        } else {
          this.$message.error(res.msg)
        }
      }).catch(e => {
        this.$message.error(e.message);
      })
    },
    searchQuery () {
      this.loadData(1)
    },
    handleTableChange (pageNum, pageSize) {
      this.queryParam.pageNum = pageNum;
      this.queryParam.pageSize = pageSize;
      this.loadData();
    },
    modalFormOk(data) {
      const form = {
        ...data,
        id: this.versionId
      };
      filingTaxGroupUpdate(form).then(res => {
        this.$refs.modalForm.closeLoading();
        this.$refs.modalForm.close();
        if (res.code === 1000) {
          this.$message.success(res.msg);
          this.loadData(this.queryParam.pageNum);
        } else {
          this.$message.error(res.msg);
        }
      }).catch(e => {
        this.$refs.modalForm.closeLoading();
        this.$message.error(e.message);
      })
    },
    // handleAdd () {
    //   this.versionId = undefined;
    //   this.$refs.modalForm.add();
    //   this.$refs.modalForm.title = "1";
    //   this.$refs.modalForm.disableSubmit = false;
    // },
    handleEdit (record) {
      this.groupId = record.id;
      this.versionId = record.id;
      this.errorMessage = record.message;
      this.status = record.status;
      this.pageType = 'edit';
      this.$refs.modalForm.edit(record);
      // this.$refs.modalForm.disableSubmit = false;
    },
    handleEditDetail(record) {
      this.groupId = record.id;
      this.versionId = record.id;
      this.errorMessage = record.message;
      this.status = record.status;
      this.pageType = 'detail';
      this.$refs.modalForm.edit(record);
    },

    toDonghaoHandle(record) {
      const self = this;
      this.$confirm({

        title: 'InputRedirectReason',
        content: h => {
          return <div>
            <div>
              Reason:<input id = 'reason' type = 'text' />
            </div>
          </div>
        },
        onOk() {
          self.loading = true;
          var reason = document.getElementById("reason").value;

          if(!reason.trim()){
            alert('RedirectReasoncannot be empty');

            self.loadData();

            return false;
          }
          var model = {
            id: record.id,
            status: '10',
            errorMessage: reason
          }
          filingTaxGroupUpdate1(model).then(res => {
            if (res.code === 1000) {
              self.loading = false;
              self.$message.success(res.msg);
              self.loadData(self.queryParam.pageNum);
            } else {
              self.loading = false;
              self.$message.error(res.msg);
            }
          }).catch(e => {
            self.loading = false;
            self.$message.error(e.message);
          })
        },
      });
    },
    changeModal (visible) {
      this.visible = visible;
    },
    searchReset () {
      this.queryParam.pageNum=1
      this.queryParam.pageSize=10
      this.queryParam.statuses=[]
      this.queryParam.name=''
      this.queryParam.thirdName=''
      this.queryParam.createdTime=[]
    },
    transformTime(time) {
      return moment(time).format('YYYY-MM-DD')
    },
    getQueryParams() {
      const { createdTime } = this.queryParam;
      const data = {
        ...this.queryParam,
        startDate: createdTime && this.transformTime(createdTime[0]),
        endDate: createdTime && this.transformTime(createdTime[1]),
      }
      if(this.queryParam.createdTime.length === 0) {
        data['startDate'] = ''
        data['endDate']=''
      }
      var param = Object.assign({}, data)
      return filterObj(param)
    },
    loadData (pageNum) {
      if(pageNum) { this.queryParam.pageNum = pageNum; }
      this.loading = true;
      var params = this.getQueryParams()// Query conditions
      filingTaxGroupList(Object.assign({}, params)).then(res => {
        this.loading = false;
        this.total = res.data.total
        this.dataSource = res.data.rows;
      }).catch(e => {
        this.loading = false;
        this.$message.error(e.message);
      });
    },
    statusText(status) {
      for(var i in this.statuses) {
        if(status === this.statuses[i].value) {
          return this.statuses[i].label
        }
      }
    },
    rowClassName(record,index) {
      var status = record.status;
      if('10' == status) {
        return 'orderFilingTaxErrorColor';
      }
      return '';
    },
  },
}
</script>
<style scoped>
@import '~@/assets/less/common.less';
</style>
<style>
.orderFilingTaxErrorColor {
  background-color: red;
}
</style>